import type { ComponentTemplate } from "schemas/generated/componentTemplates";

export const bundleBuilder: ComponentTemplate = {
  id: "826448ce-98c6-43b2-b643-17ac6b9b2438",
  storeId: null,
  scope: "left-bar",
  type: "component",
  name: "Product/Collection Bundle Builder",
  leftBarCategory: { main: "product", subCategory: "bundles" },
  preview: "product/bundle-builder-grid.svg",
  template: {
    id: "4b87cd24-4598-402b-9733-a16baf03774e",
    name: "Bundle Builder",
    type: "bundleBuilder",
    props: {
      style: {
        alignSelf: "stretch",
      },
      "style@md": {
        flexDirection: "column",
      },
      "style@sm": {
        flexDirection: "column",
      },
      allowMultipleOfSameItem: true,
      bundleTargets: "variants",
      bundleTargetType: "products",
      productsWithVariants: [],
      bundleDiscountThresholds: [
        {
          discount: {
            type: "percentageOff",
            value: 10,
          },
          quantity: 3,
        },
        {
          discount: {
            type: "percentageOff",
            value: 20,
          },
          quantity: 5,
        },
      ],
    },
    children: [
      {
        id: "a3bcefb1-92af-4363-a87c-95408bb50b33",
        name: "Bundle Header (Mobile)",
        type: "bundleHeader",
        props: {
          style: {
            display: "none",
          },
          "style@md": {
            display: "block",
          },
          "style@sm": {
            display: "block",
          },
        },
        children: [
          {
            id: "ff594c0c-b275-424d-9167-a1e17c631b65",
            type: "text",
            props: {
              text: "<h2>Build Your Bundle</h2>",
              style: {
                fontSize: "32px",
                fontWeight: 700,
                lineHeight: "39px",
              },
            },
          },
          {
            id: "d181869d-d4e9-4fff-9110-f06371ba8061",
            name: "Description of bundle goes here",
            type: "text",
            props: {
              text: "<p>A description of the bundle offering.</p>",
              style: {
                fontSize: "16px",
                fontWeight: 600,
                lineHeight: "19px",
                marginBottom: "24px",
                letterSpacing: "-0.05em",
              },
            },
          },
          {
            id: "effa01e1-a767-42f2-8616-9729f06f0dc7",
            name: "Bundle Tier Selector 3",
            type: "bundleTierSelector",
            props: {},
            children: [],
          },
        ],
      },
      {
        id: "8433fa48-6127-4333-b2af-1577f7941e8f",
        name: "Bundle Grid",
        type: "bundleGrid",
        props: {
          layout: "grid",
          style: {
            marginLeft: "12px",
            marginRight: "12px",
            display: "grid",
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
            __numberOfColumns: 3,
            __flexGap: 0,
            columnGap: 0,
            rowGap: 0,
            flexGrow: 1,
          },
          "style@md": {
            display: "grid",
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
            __numberOfColumns: 3,
          },
          "style@sm": {
            display: "grid",
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            __numberOfColumns: 2,
          },
        },
        children: [
          {
            id: "13dd8709-49a4-424e-b6c6-0bf24a823f9e",
            name: "Bundle Item Tile",
            type: "bundleProductTile",
            props: {
              style: {
                fontWeight: 400,
                flexGrow: 1,
              },
            },
            children: [
              {
                id: "a6024e4d-1263-4407-b5c5-20a1d63d76ee",
                name: "Variant Selectors",
                type: "bundleProductVariantSelector",
                props: {
                  style: {
                    fontWeight: 400,
                    borderTopWidth: "1px",
                    borderRightWidth: "1px",
                    borderBottomWidth: "1px",
                    borderLeftWidth: "1px",
                    borderTopColor: "#C8D5E1FF",
                    borderRightColor: "#C8D5E1FF",
                    borderBottomColor: "#C8D5E1FF",
                    borderLeftColor: "#C8D5E1FF",
                    borderTopStyle: "solid",
                    borderRightStyle: "solid",
                    borderBottomStyle: "solid",
                    borderLeftStyle: "solid",
                  },
                },
                children: [],
              },
              {
                id: "2a3ede30-4c6e-49ab-b3a0-c4488a9c0f81",
                name: "Add To Bundle Button",
                type: "bundleAddToBundleButton",
                props: {
                  style: {
                    fontWeight: 400,
                  },
                },
                children: [],
              },
            ],
          },
        ],
      },
      {
        id: "8c22db00-2176-450a-9476-3e510b8a907a",
        name: "Bundle Summary (Desktop)",
        type: "bundleSummary",
        props: {
          style: {
            display: "flex",
            width: "500px",
            __width: "500px",
            flexDirection: "column",
          },
          "style@md": {
            display: "none",
          },
          "style@sm": {
            display: "none",
          },
        },
        children: [
          {
            id: "ddddc162-a9c6-4501-9a39-16cf9dfb5907",
            type: "text",
            props: {
              text: "<h2>Build Your Bundle</h2>",
              style: {
                fontSize: "32px",
                fontWeight: 700,
                lineHeight: "39px",
              },
            },
          },
          {
            id: "0fb6e9e5-c378-4a9f-930f-c9fb4a90db97",
            name: "Description of bundle goes here",
            type: "text",
            props: {
              text: "<p>A description of the bundle offering.</p>",
              style: {
                fontSize: "16px",
                fontWeight: 600,
                lineHeight: "19px",
                marginBottom: "24px",
                letterSpacing: "-0.05em",
              },
            },
          },
          {
            id: "9d860cfd-2baa-451e-bf90-33f52576fb5d",
            name: "Bundle Tier Selector",
            type: "bundleTierSelector",
            props: {},
            children: [],
          },
          {
            id: "db09be8a-2d7c-4ef1-a6c1-14de55c3ca5f",
            name: "Bundle Items",
            type: "bundleCart",
            props: {},
            children: [],
          },
          {
            id: "14ea39ef-7b46-4e76-9a1a-5a4a0a5aad73",
            name: "Bundle Progress Bar",
            type: "bundleProgressBar",
            props: {
              style: {
                fontWeight: 400,
              },
              backgroundColor: "#F00600FF",
            },
            children: [],
          },
          {
            id: "44469a6c-5e18-415f-b83b-183cc4e1c3e3",
            name: "Bundle Cart Total",
            type: "bundleCartTotals",
            props: {
              style: {},
            },
            children: [],
          },
          {
            id: "072560a5-bf79-412b-8c30-1a190aa29431",
            name: "Add To Cart Button",
            type: "bundleAddToCartButton",
            props: {
              style: {
                color: "#FFFFFFFF",
                width: "100%",
                padding: "12px 16px",
                fontSize: "16px",
                textAlign: "center",
                fontWeight: "600",
                backgroundColor: "#000000FF",
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
                borderBottomLeftRadius: "6px",
                borderBottomRightRadius: "6px",
              },
            },
            children: [],
          },
        ],
      },
      {
        id: "f2a676a9-cd87-4074-98f6-a2205d149b04",
        name: "Bundle Footer (Mobile)",
        type: "bundleFooter",
        children: [
          {
            id: "439458d3-bae4-4d72-ba26-3ae101c5a961",
            name: "Add To Cart Button",
            type: "bundleAddToCartButton",
            props: {
              style: {
                color: "#FFFFFFFF",
                width: "100%",
                padding: "12px 16px",
                fontSize: "16px",
                textAlign: "center",
                fontWeight: "600",
                backgroundColor: "#000000FF",
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
                borderBottomLeftRadius: "6px",
                borderBottomRightRadius: "6px",
              },
            },
            children: [],
          },
        ],
        props: {
          style: {
            display: "none",
          },
          "style@md": {
            top: "initial",
            left: "auto",
            right: "auto",
            width: "100vw",
            bottom: "0px",
            zIndex: "30",
            display: "block",
            flexGrow: "unset",
            position: "sticky",
            alignSelf: "auto",
            __transform: {
              skewX: "0deg",
              skewY: "0deg",
              scaleX: "100%",
              scaleY: "100%",
              scaleZ: "100%",
              rotateX: "0deg",
              rotateY: "0deg",
              rotateZ: "0deg",
              translateX: "0px",
              translateY: "0px",
              translateZ: "0px",
            },
          },
          "style@sm": {
            top: "initial",
            left: "auto",
            right: "auto",
            width: "100vw",
            bottom: "0px",
            zIndex: "30",
            __width: "100vw",
            display: "block",
            flexGrow: "unset",
            position: "sticky",
            alignSelf: "auto",
            __transform: {
              skewX: "0deg",
              skewY: "0deg",
              scaleX: "100%",
              scaleY: "100%",
              scaleZ: "100%",
              rotateX: "0deg",
              rotateY: "0deg",
              rotateZ: "0deg",
              translateX: "0px",
              translateY: "0px",
              translateZ: "0px",
            },
          },
        },
      },
    ],
  },
};

export const pdpBundleBuilder: ComponentTemplate = {
  id: "b7e2c1a2-1e3a-4b7a-9c2e-2e1a3b4c5d6e",
  storeId: null,
  scope: "left-bar",
  type: "component",
  name: "Product/PDP Bundle Builder",
  leftBarCategory: { main: "product", subCategory: "bundles" },
  preview: "product/bundle-builder-pdp.svg",
  template: {
    id: "b979ec4a-18fe-4007-9483-0e092db09130",
    name: "Bundle Builder",
    type: "bundleBuilder",
    props: {
      style: {
        alignSelf: "stretch",
      },
      "style@md": {
        flexDirection: "column",
      },
      "style@sm": {
        flexDirection: "column",
      },
      bundleTargets: "variants",
      bundleTargetType: "products",
      productsWithVariants: [],
      allowMultipleOfSameItem: true,
      bundleDiscountThresholds: [
        {
          discount: {
            type: "percentageOff",
            value: 10,
          },
          quantity: 3,
        },
        {
          discount: {
            type: "percentageOff",
            value: 20,
          },
          quantity: 5,
        },
      ],
    },
    children: [
      {
        id: "c99f288b-8a67-4d8c-8152-61739f47e81a",
        name: "Container 1",
        type: "container",
        props: {
          style: {
            display: "flex",
            flexGrow: 1,
            maxWidth: "100%",
            alignSelf: "stretch",
            alignItems: "center",
            justifyContent: "center",
          },
        },
        children: [
          {
            id: "6ef565aa-ccb9-4746-8022-3d51f86f0926",
            name: "slideshow carousel",
            type: "carouselV3",
            props: {
              style: {
                display: "flex",
                __flexGap: "24px",
                alignSelf: "stretch",
                flexBasis: 0,
                alignItems: "flex-start",
                flexDirection: "column",
                justifyContent: "flex-start",
              },
              "style@sm": {
                width: "auto",
                __width: "100%",
                display: "flex",
                flexGrow: 1,
                __flexGap: "16px",
                flexDirection: "column",
              },
              _animationStyle: "fade",
            },
            children: [
              {
                id: "dcddd010-f79c-4a4f-88b0-1c509b2bc106",
                name: "Slides 1",
                type: "carouselV3Slides",
                props: {
                  style: {
                    __width: "600px",
                    display: "flex",
                    __height: "400px",
                    maxWidth: "656px",
                    overflow: "hidden",
                    alignSelf: "stretch",
                    flexBasis: 0,
                  },
                  "style@md": {
                    width: "auto",
                    alignSelf: "stretch",
                  },
                  "style@sm": {
                    width: "auto",
                    height: "auto",
                    __width: "350px",
                    __height: "350px",
                    flexGrow: 1,
                    maxWidth: "100%",
                    alignSelf: "stretch",
                    flexBasis: "auto",
                  },
                },
                children: [
                  {
                    id: "22d3584b-a873-4536-8f56-d01e6a4e98e2",
                    name: "Slide 1",
                    type: "container",
                    props: {
                      style: {
                        height: "100%",
                        display: "flex",
                        flexGrow: 1,
                        flexBasis: 0,
                        alignItems: "center",
                        flexDirection: "column",
                        justifyContent: "center",
                      },
                      "style@sm": {
                        width: "auto",
                        height: "auto",
                        flexGrow: 1,
                        alignSelf: "stretch",
                      },
                    },
                    children: [
                      {
                        id: "cadebf56-a9b9-40f9-91a8-ca38340f3ee3",
                        name: "Image 1",
                        type: "image",
                        props: {
                          style: {
                            width: "100%",
                            height: "100%",
                            __width: "100%",
                            __height: "100%",
                            flexBasis: 0,
                            objectFit: "cover",
                            __imageSource:
                              "https://images.unsplash.com/photo-1504198266287-1659872e6590?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8MTd8fHxlbnwwfHx8fHw%3D",
                            __imageAltText:
                              "A single green leaf against a white background.",
                          },
                          loading: "lazy",
                          "style@sm": {
                            width: "100%",
                            __width: "100%",
                            alignSelf: "auto",
                          },
                        },
                        markers: {
                          _aiGeneratedAltText: true,
                        },
                      },
                    ],
                  },
                  {
                    id: "11a9701d-d03c-40b0-8c39-e6949551ce85",
                    name: "Slide 2",
                    type: "container",
                    props: {
                      style: {
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexBasis: 0,
                        alignItems: "center",
                        flexDirection: "column",
                        justifyContent: "center",
                      },
                      "style@sm": {
                        width: "auto",
                        height: "auto",
                        flexGrow: 1,
                        alignSelf: "stretch",
                      },
                    },
                    children: [
                      {
                        id: "0a19abc9-0984-4a54-86c5-d2fb2e101f9b",
                        name: "Image 2",
                        type: "image",
                        props: {
                          style: {
                            width: "100%",
                            height: "100%",
                            __width: "100%",
                            __height: "100%",
                            objectFit: "cover",
                            __imageSource:
                              "https://images.unsplash.com/photo-1504204267155-aaad8e81290d?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8MTR8fHxlbnwwfHx8fHw%3D",
                            __imageAltText:
                              "A single green leaf in a clear glass of water on white background.",
                          },
                          loading: "lazy",
                        },
                        markers: {
                          _aiGeneratedAltText: true,
                        },
                      },
                    ],
                  },
                  {
                    id: "6516a70f-d7ac-4818-a5d6-c6e928a63bff",
                    name: "Slide 3",
                    type: "container",
                    props: {
                      style: {
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexBasis: 0,
                        alignItems: "center",
                        flexDirection: "column",
                        justifyContent: "center",
                      },
                      "style@sm": {
                        width: "auto",
                        height: "auto",
                        flexGrow: 1,
                        alignSelf: "stretch",
                      },
                    },
                    children: [
                      {
                        id: "9131a9da-dfc2-41a9-bb33-8a1145a58e92",
                        name: "Image 3",
                        type: "image",
                        props: {
                          style: {
                            width: "100%",
                            height: "100%",
                            __width: "100%",
                            __height: "100%",
                            objectFit: "cover",
                            __imageSource:
                              "https://images.unsplash.com/photo-1471086569966-db3eebc25a59?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8MjZ8fHxlbnwwfHx8fHw%3D",
                            __imageAltText:
                              "A single Monstera leaf in a clear glass vase against a white background.",
                          },
                          loading: "lazy",
                        },
                        markers: {
                          _aiGeneratedAltText: true,
                        },
                      },
                    ],
                  },
                  {
                    id: "fdb9e889-e5d1-43bf-a341-efb56bfbd701",
                    name: "Slide 4",
                    type: "container",
                    props: {
                      style: {
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexBasis: 0,
                        alignItems: "center",
                        flexDirection: "column",
                        justifyContent: "center",
                      },
                      "style@sm": {
                        width: "auto",
                        height: "auto",
                        flexGrow: 1,
                        alignSelf: "stretch",
                      },
                    },
                    children: [
                      {
                        id: "f0527092-4ccc-4883-a37c-c5d23339ddd5",
                        name: "Image 4",
                        type: "image",
                        props: {
                          style: {
                            width: "100%",
                            height: "100%",
                            __width: "100%",
                            __height: "100%",
                            objectFit: "cover",
                            __imageSource:
                              "https://images.unsplash.com/photo-1655658233701-a0bada796e94?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8MXx8fGVufDB8fHx8fA%3D%3D",
                            __imageAltText:
                              "Green palm leaf beside two blank white cards on a white background.",
                          },
                          loading: "lazy",
                        },
                        markers: {
                          _aiGeneratedAltText: true,
                        },
                      },
                    ],
                  },
                ],
              },
              {
                id: "3c51ef54-b372-46a2-b9d6-7dddddb8276a",
                name: "Container 2",
                type: "container",
                props: {
                  style: {
                    display: "flex",
                    maxWidth: "100%",
                    __flexGap: "24px",
                    alignSelf: "stretch",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                  },
                  "style@sm": {
                    width: "auto",
                    __flexGap: "8px",
                  },
                },
                children: [
                  {
                    id: "07731346-7d73-493b-8c4e-5edcc33a7104",
                    name: "Previous Button 1",
                    type: "carouselV3Control",
                    props: {
                      style: {
                        cursor: "pointer",
                        display: "flex",
                        flexGrow: "unset",
                        flexWrap: "wrap",
                        alignSelf: "stretch",
                        flexBasis: "auto",
                        alignItems: "center",
                        justifyContent: "center",
                      },
                      direction: "previous",
                    },
                    children: [
                      {
                        id: "0754a535-6537-43a4-a5a0-d0bd36cf4792",
                        type: "icon",
                        props: {
                          style: {
                            width: "40px",
                            height: "40px",
                            __width: "40px",
                            __height: "40px",
                          },
                          iconName: "chevronLeft",
                          "style@sm": {
                            width: "24px",
                            height: "24px",
                            __width: "24px",
                            __height: "24px",
                            flexGrow: "unset",
                          },
                        },
                        variantOverrides: {},
                      },
                    ],
                    variants: [
                      {
                        id: "64a410e4-bc18-46e7-ba5d-299fd5665b36",
                        name: "default",
                        query: null,
                        componentOverrides: null,
                      },
                      {
                        id: "24bdbb9b-947a-412e-b0f4-66fecd208fb9",
                        name: "First Item",
                        query: {
                          type: "expression",
                          operator: "or",
                          statements: [
                            {
                              id: "bf8b0b4c-79fd-4043-a18b-9840a038a6e3",
                              field: "state.group.isFirstItemActive",
                              value: null,
                              operator: null,
                            },
                          ],
                        },
                        componentOverrides: null,
                      },
                    ],
                    variantOverrides: {
                      "24bdbb9b-947a-412e-b0f4-66fecd208fb9": {
                        componentOverrides: {
                          "0754a535-6537-43a4-a5a0-d0bd36cf4792": {
                            props: {
                              style: {
                                opacity: "20%",
                              },
                            },
                          },
                          "07731346-7d73-493b-8c4e-5edcc33a7104": {
                            props: {
                              style: {
                                cursor: "default",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  {
                    id: "aa5fdc63-e566-45bb-9d42-d167f7a96753",
                    name: "Slides 2",
                    type: "carouselV3Slides",
                    props: {
                      style: {
                        __width: "1197px",
                        display: "flex",
                        flexGrow: 1,
                        overflow: "hidden",
                        __flexGap: "16px",
                        alignSelf: "stretch",
                        alignItems: "center",
                        justifyContent: "center",
                      },
                      "style@sm": {
                        __flexGap: "12px",
                      },
                      _autoWidth: true,
                      _activeArea: "first",
                      _useCustomConfig: true,
                      _slideClickTransition: true,
                    },
                    children: [
                      {
                        id: "24ffae06-ad5c-43c9-bedb-6ea916b5cb8a",
                        name: "For Slide 1",
                        type: "image",
                        props: {
                          style: {
                            height: "80px",
                            __width: "80px",
                            opacity: "100%",
                            __height: "80px",
                            objectFit: "cover",
                            __imageSource:
                              "https://images.unsplash.com/photo-1504198266287-1659872e6590?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8MTd8fHxlbnwwfHx8fHw%3D",
                            __imageAltText:
                              "A single green leaf against a white background.",
                          },
                          loading: "lazy",
                          "style@sm": {
                            width: "auto",
                            cursor: "pointer",
                            height: "56px",
                            __width: "64px",
                            __height: "56px",
                            flexGrow: "unset",
                          },
                        },
                        markers: {
                          _aiGeneratedAltText: true,
                        },
                        variants: [
                          {
                            id: "9f11e1fb-1968-4eb5-a94b-c71093856dd2",
                            name: "default",
                            query: null,
                            componentOverrides: null,
                          },
                          {
                            id: "1700b78a-856c-46b5-89db-ae67def389d7",
                            name: "Active",
                            query: {
                              type: "expression",
                              operator: "or",
                              statements: [
                                {
                                  id: "7139f491-1640-4972-90f1-f6a3d3a2a168",
                                  field: "state.group.isCurrentItemActive",
                                  value: null,
                                  operator: null,
                                },
                              ],
                            },
                            componentOverrides: null,
                          },
                        ],
                        variantOverrides: {
                          "1700b78a-856c-46b5-89db-ae67def389d7": {
                            componentOverrides: {
                              "24ffae06-ad5c-43c9-bedb-6ea916b5cb8a": {
                                props: {
                                  style: {
                                    opacity: "100%",
                                    borderColor: null,
                                    borderStyle: null,
                                    borderWidth: null,
                                    borderTopColor: "#000000",
                                    borderTopStyle: "solid",
                                    borderTopWidth: "2px",
                                    borderLeftColor: "#000000",
                                    borderLeftStyle: "solid",
                                    borderLeftWidth: "2px",
                                    borderRightColor: "#000000",
                                    borderRightStyle: "solid",
                                    borderRightWidth: "2px",
                                    borderBottomColor: "#000000",
                                    borderBottomStyle: "solid",
                                    borderBottomWidth: "2px",
                                  },
                                  "style@sm": {
                                    width: "auto",
                                    flexGrow: "unset",
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                      {
                        id: "266dd76b-6e04-403a-94bd-83d5ce3ca1d6",
                        name: "For Slide 2",
                        type: "image",
                        props: {
                          style: {
                            height: "80px",
                            __width: "80px",
                            opacity: "100%",
                            __height: "80px",
                            objectFit: "cover",
                            __imageSource:
                              "https://images.unsplash.com/photo-1504204267155-aaad8e81290d?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8MTR8fHxlbnwwfHx8fHw%3D",
                            __imageAltText:
                              "A single palm leaf in a clear glass of water on a white background.",
                            borderTopLeftRadius: "0%",
                            borderTopRightRadius: "0%",
                            borderBottomLeftRadius: "0%",
                            borderBottomRightRadius: "0%",
                          },
                          loading: "lazy",
                          "style@sm": {
                            width: "auto",
                            cursor: "pointer",
                            height: "56px",
                            __width: "64px",
                            __height: "56px",
                            flexGrow: "unset",
                          },
                        },
                        markers: {
                          _aiGeneratedAltText: true,
                        },
                        variants: [
                          {
                            id: "f600605f-8f71-4147-986d-7480915d5c19",
                            name: "default",
                            query: null,
                            componentOverrides: null,
                          },
                          {
                            id: "cc7dbe02-78ea-43b5-8a26-2e60648f1b67",
                            name: "Active",
                            query: {
                              type: "expression",
                              operator: "or",
                              statements: [
                                {
                                  id: "2ec7d288-c57c-49ba-8ffe-85e0aade3494",
                                  field: "state.group.isCurrentItemActive",
                                  value: null,
                                  operator: null,
                                },
                              ],
                            },
                            componentOverrides: null,
                          },
                        ],
                        variantOverrides: {
                          "cc7dbe02-78ea-43b5-8a26-2e60648f1b67": {
                            componentOverrides: {
                              "266dd76b-6e04-403a-94bd-83d5ce3ca1d6": {
                                props: {
                                  style: {
                                    opacity: "100%",
                                    borderColor: null,
                                    borderStyle: null,
                                    borderWidth: null,
                                    borderTopColor: "#000000",
                                    borderTopStyle: "solid",
                                    borderTopWidth: "2px",
                                    borderLeftColor: "#000000",
                                    borderLeftStyle: "solid",
                                    borderLeftWidth: "2px",
                                    borderRightColor: "#000000",
                                    borderRightStyle: "solid",
                                    borderRightWidth: "2px",
                                    borderBottomColor: "#000000",
                                    borderBottomStyle: "solid",
                                    borderBottomWidth: "2px",
                                  },
                                  "style@sm": {
                                    width: "auto",
                                    flexGrow: "unset",
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                      {
                        id: "4c36e188-afd6-4137-b7b6-b898ba3d48f9",
                        name: "For Slide 3",
                        type: "image",
                        props: {
                          style: {
                            height: "80px",
                            __width: "80px",
                            opacity: "100%",
                            __height: "80px",
                            objectFit: "cover",
                            __imageSource:
                              "https://images.unsplash.com/photo-1471086569966-db3eebc25a59?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8MjZ8fHxlbnwwfHx8fHw%3D",
                            __imageAltText:
                              "A single monstera leaf in a clear glass vase against a white background.",
                          },
                          loading: "lazy",
                          "style@sm": {
                            width: "auto",
                            cursor: "pointer",
                            height: "56px",
                            __width: "64px",
                            __height: "56px",
                            flexGrow: "unset",
                          },
                        },
                        markers: {
                          _aiGeneratedAltText: true,
                        },
                        variants: [
                          {
                            id: "b1f3a50c-0bce-4719-97c5-7cab3be147f5",
                            name: "default",
                            query: null,
                            componentOverrides: null,
                          },
                          {
                            id: "87f71df5-648d-497a-99ec-befb03ee7a12",
                            name: "Active",
                            query: {
                              type: "expression",
                              operator: "or",
                              statements: [
                                {
                                  id: "e4169129-12fd-43fa-84cd-15c077a6af67",
                                  field: "state.group.isCurrentItemActive",
                                  value: null,
                                  operator: null,
                                },
                              ],
                            },
                            componentOverrides: null,
                          },
                        ],
                        variantOverrides: {
                          "87f71df5-648d-497a-99ec-befb03ee7a12": {
                            componentOverrides: {
                              "4c36e188-afd6-4137-b7b6-b898ba3d48f9": {
                                props: {
                                  style: {
                                    opacity: "100%",
                                    borderColor: null,
                                    borderStyle: null,
                                    borderWidth: null,
                                    borderTopColor: "#000000",
                                    borderTopStyle: "solid",
                                    borderTopWidth: "2px",
                                    borderLeftColor: "#000000",
                                    borderLeftStyle: "solid",
                                    borderLeftWidth: "2px",
                                    borderRightColor: "#000000",
                                    borderRightStyle: "solid",
                                    borderRightWidth: "2px",
                                    borderBottomColor: "#000000",
                                    borderBottomStyle: "solid",
                                    borderBottomWidth: "2px",
                                  },
                                  "style@sm": {
                                    width: "auto",
                                    flexGrow: "unset",
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                      {
                        id: "bf60b550-5650-4a20-9fad-ad0a5852fa21",
                        name: "For Slide 4",
                        type: "image",
                        props: {
                          style: {
                            height: "80px",
                            __width: "80px",
                            opacity: "100%",
                            __height: "80px",
                            objectFit: "cover",
                            __imageSource:
                              "https://images.unsplash.com/photo-1655658233701-a0bada796e94?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8MXx8fGVufDB8fHx8fA%3D%3D",
                            __imageAltText:
                              "Green palm leaf beside blank white cards on a plain background.",
                            borderTopLeftRadius: "0%",
                            borderTopRightRadius: "0%",
                            borderBottomLeftRadius: "0%",
                            borderBottomRightRadius: "0%",
                          },
                          loading: "lazy",
                          "style@sm": {
                            width: "auto",
                            cursor: "pointer",
                            height: "56px",
                            __width: "64px",
                            __height: "56px",
                            flexGrow: "unset",
                          },
                        },
                        markers: {
                          _aiGeneratedAltText: true,
                        },
                        variants: [
                          {
                            id: "405178ae-ebde-42ac-a161-f1c51a018280",
                            name: "default",
                            query: null,
                            componentOverrides: null,
                          },
                          {
                            id: "ec82e709-3ccd-4d6e-8052-6728adb5b72f",
                            name: "Active",
                            query: {
                              type: "expression",
                              operator: "or",
                              statements: [
                                {
                                  id: "a577620a-970e-494c-8322-6984a9d55f7d",
                                  field: "state.group.isCurrentItemActive",
                                  value: null,
                                  operator: null,
                                },
                              ],
                            },
                            componentOverrides: null,
                          },
                        ],
                        variantOverrides: {
                          "ec82e709-3ccd-4d6e-8052-6728adb5b72f": {
                            componentOverrides: {
                              "bf60b550-5650-4a20-9fad-ad0a5852fa21": {
                                props: {
                                  style: {
                                    opacity: "100%",
                                    borderColor: null,
                                    borderStyle: null,
                                    borderWidth: null,
                                    borderTopColor: "#000000",
                                    borderTopStyle: "solid",
                                    borderTopWidth: "2px",
                                    borderLeftColor: "#000000",
                                    borderLeftStyle: "solid",
                                    borderLeftWidth: "2px",
                                    borderRightColor: "#000000",
                                    borderRightStyle: "solid",
                                    borderRightWidth: "2px",
                                    borderBottomColor: "#000000",
                                    borderBottomStyle: "solid",
                                    borderBottomWidth: "2px",
                                  },
                                  "style@sm": {
                                    width: "auto",
                                    flexGrow: "unset",
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                  {
                    id: "acef5278-157a-4af7-b2f5-d720d13fbf0e",
                    name: "Next Button 1",
                    type: "carouselV3Control",
                    props: {
                      style: {
                        cursor: "pointer",
                        display: "flex",
                        alignSelf: "stretch",
                        alignItems: "center",
                        justifyContent: "center",
                      },
                      "style@md": {
                        width: "auto",
                        flexGrow: "unset",
                      },
                      direction: "next",
                    },
                    children: [
                      {
                        id: "40904e04-f394-4418-9350-a29d3d60e00f",
                        type: "icon",
                        props: {
                          style: {
                            width: "40px",
                            height: "40px",
                            __width: "40px",
                            __height: "40px",
                          },
                          iconName: "chevronRight",
                          "style@sm": {
                            width: "24px",
                            height: "24px",
                            __width: "24px",
                            __height: "24px",
                            flexGrow: "unset",
                          },
                        },
                        variantOverrides: {},
                      },
                    ],
                    variants: [
                      {
                        id: "8c81f9c7-0cdc-4483-8feb-48848563213c",
                        name: "default",
                        query: null,
                        componentOverrides: null,
                      },
                      {
                        id: "007771a7-8daf-4b0e-9a82-dc4ca4ca9542",
                        name: "Last Item",
                        query: {
                          type: "expression",
                          operator: "or",
                          statements: [
                            {
                              id: "fa7db26c-7755-450b-b10f-b5f0f5c6a624",
                              field: "state.group.isLastItemActive",
                              value: null,
                              operator: null,
                            },
                          ],
                        },
                        componentOverrides: null,
                      },
                    ],
                    variantOverrides: {
                      "007771a7-8daf-4b0e-9a82-dc4ca4ca9542": {
                        componentOverrides: {
                          "40904e04-f394-4418-9350-a29d3d60e00f": {
                            props: {
                              style: {
                                opacity: "20%",
                              },
                            },
                          },
                          "acef5278-157a-4af7-b2f5-d720d13fbf0e": {
                            props: {
                              style: {
                                cursor: "default",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "ef09d895-3604-4ed9-a89c-798af6cc7589",
        name: "Bundle Summary",
        type: "bundleSummary",
        props: {
          style: {
            width: "500px",
            zIndex: 1,
            __width: "500px",
            display: "block",
            position: "sticky",
            __transform: {
              translateX: "0px",
              translateY: "0px",
            },
          },
          "style@md": {
            top: "auto",
            left: "auto",
            right: "auto",
            width: "auto",
            bottom: "auto",
            display: "flex",
            flexGrow: "unset",
            flexWrap: "nowrap",
            position: "relative",
            alignSelf: "auto",
            __transform: {
              translateX: "0px",
              translateY: "0px",
            },
            flexDirection: "column",
          },
          "style@sm": {
            display: "inline",
          },
        },
        children: [
          {
            id: "10ebb05e-3fee-4b2a-80ba-5445a1d7c290",
            name: "Star Rating & Text",
            type: "container",
            props: {
              style: {
                display: "flex",
                maxWidth: "100%",
                __flexGap: "10px",
                alignSelf: "stretch",
                alignItems: "center",
                justifyContent: "flex-start",
              },
            },
            children: [
              {
                id: "b215f4e7-0d3c-4145-bd5a-e15a4e425c48",
                name: "Star Rating 1",
                type: "starRating",
                props: {
                  _size: "16px",
                  style: {
                    display: "flex",
                    flexDirection: "row",
                  },
                  _starColor: "#000000",
                  _starCount: 5,
                  _totalStars: 5,
                },
              },
              {
                id: "2c60246c-aaa2-43d4-b122-2e7738fd3187",
                type: "text",
                props: {
                  text: "<p>100 Reviews</p>",
                  style: {
                    fontSize: "16px",
                    lineHeight: "24px",
                  },
                },
              },
            ],
          },
          {
            id: "e1f77ba6-d71e-4770-b905-1c325cb7ec2c",
            type: "text",
            props: {
              text: "<h2>Build Your Bundle</h2>",
              style: {
                fontSize: "32px",
                fontWeight: 700,
                lineHeight: "39px",
              },
            },
          },
          {
            id: "13eeef7c-cfdb-4a10-aefe-c323fd6f58b6",
            name: "Description of bundle goes here",
            type: "text",
            props: {
              text: "<p>A description of the bundle offering.</p>",
              style: {
                fontSize: "16px",
                fontWeight: 600,
                lineHeight: "19px",
                marginBottom: "24px",
                letterSpacing: "-0.05em",
              },
            },
          },
          {
            id: "723e43de-d63e-4355-b20b-155fdc2e4a43",
            name: "Bundle Tier Selector",
            type: "bundleTierSelector",
            props: {},
            children: [],
          },
          {
            id: "df95c01f-0e44-45f3-8fb6-baa843c516e7",
            name: "Bundle Item List",
            type: "bundleGrid",
            props: {
              style: {
                display: "flex",
                flexDirection: "column",
              },
            },
            children: [
              {
                id: "9012fe2e-4ea9-48ca-8338-f8e048a49149",
                name: "Bundle Item Tile",
                type: "bundleProductTile",
                props: {
                  style: {
                    fontWeight: 400,
                    paddingTop: "12px",
                    paddingLeft: "12px",
                    paddingRight: "12px",
                    flexDirection: "column",
                    paddingBottom: "12px",
                    borderTopColor: "#C8D5E1FF",
                    borderTopStyle: "solid",
                    borderTopWidth: "1px",
                    borderLeftColor: "#C8D5E1FF",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1px",
                    borderRightColor: "#C8D5E1FF",
                    borderRightStyle: "solid",
                    borderRightWidth: "1px",
                    borderBottomColor: "#C8D5E1FF",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1px",
                    borderTopLeftRadius: "8px",
                    borderTopRightRadius: "8px",
                    borderBottomLeftRadius: "8px",
                    borderBottomRightRadius: "8px",
                  },
                  layout: "horizontal",
                },
                children: [
                  {
                    id: "b0451e3d-bebf-4a6e-840f-ee63a37955a7",
                    name: "Variant Selectors",
                    type: "bundleProductVariantSelector",
                    props: {
                      style: {
                        fontWeight: 400,
                        borderTopColor: "#C8D5E1FF",
                        borderTopStyle: "solid",
                        borderTopWidth: "1px",
                        borderLeftColor: "#C8D5E1FF",
                        borderLeftStyle: "solid",
                        borderLeftWidth: "1px",
                        borderRightColor: "#C8D5E1FF",
                        borderRightStyle: "solid",
                        borderRightWidth: "1px",
                        borderBottomColor: "#C8D5E1FF",
                        borderBottomStyle: "solid",
                        borderBottomWidth: "1px",
                      },
                    },
                    children: [],
                  },
                  {
                    id: "7d3d1c98-4c28-47ea-828c-9ecd7645e606",
                    name: "Add To Bundle Button",
                    type: "bundleAddToBundleButton",
                    props: {
                      style: {
                        fontWeight: 400,
                      },
                    },
                    children: [],
                  },
                ],
              },
            ],
          },
          {
            id: "db4efc92-ab7a-4a0e-a582-cd73119fa443",
            name: "Bundle Progress Bar",
            type: "bundleProgressBar",
            props: {
              style: {
                display: "block",
                fontWeight: 400,
              },
              "style@md": {
                display: "none",
              },
              "style@sm": {
                display: "none",
              },
              backgroundColor: "#F00600FF",
            },
            children: [],
          },
          {
            id: "05f6145d-9d38-418d-a126-f2a2a1f84cd5",
            name: "Bundle Cart Total",
            type: "bundleCartTotals",
            props: {
              style: {
                display: "block",
              },
              "style@md": {
                display: "none",
              },
              "style@sm": {
                display: "none",
              },
            },
            children: [],
          },
          {
            id: "a093083b-8de1-4ace-a09e-a77b7dc9879f",
            name: "Add To Cart Button",
            type: "bundleAddToCartButton",
            props: {
              style: {
                display: "block",
                color: "#FFFFFFFF",
                width: "100%",
                padding: "12px 16px",
                fontSize: "16px",
                textAlign: "center",
                fontWeight: "600",
                backgroundColor: "#000000FF",
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
                borderBottomLeftRadius: "6px",
                borderBottomRightRadius: "6px",
              },
              "style@md": {
                display: "none",
              },
              "style@sm": {
                display: "none",
              },
            },
            children: [],
          },
        ],
      },
      {
        id: "5516d191-db40-485e-9279-d9566ac8cb69",
        name: "Bundle Footer (Mobile)",
        type: "bundleFooter",
        props: {
          style: {
            display: "none",
          },
          "style@md": {
            width: "100vw",
            top: "initial",
            left: "auto",
            right: "auto",
            bottom: "0px",
            zIndex: "30",
            display: "block",
            flexGrow: "unset",
            position: "sticky",
            alignSelf: "auto",
            paddingTop: "16px",
            __transform: {
              skewX: "0deg",
              skewY: "0deg",
              scaleX: "100%",
              scaleY: "100%",
              scaleZ: "100%",
              rotateX: "0deg",
              rotateY: "0deg",
              rotateZ: "0deg",
              translateX: "0px",
              translateY: "0px",
              translateZ: "0px",
            },
            paddingLeft: "16px",
            paddingRight: "16px",
            paddingBottom: "16px",
          },
          "style@sm": {
            width: "100vw",
            top: "initial",
            left: "auto",
            right: "auto",
            bottom: "0px",
            zIndex: "30",
            __width: "100vw",
            display: "block",
            flexGrow: "unset",
            position: "sticky",
            alignSelf: "auto",
            __transform: {
              skewX: "0deg",
              skewY: "0deg",
              scaleX: "100%",
              scaleY: "100%",
              scaleZ: "100%",
              rotateX: "0deg",
              rotateY: "0deg",
              rotateZ: "0deg",
              translateX: "0px",
              translateY: "0px",
              translateZ: "0px",
            },
          },
        },
        children: [
          {
            id: "f8ad3983-6dc7-4c97-adfb-ef27c8adb9e1",
            name: "Add To Cart Button",
            type: "bundleAddToCartButton",
            props: {
              style: {
                color: "#FFFFFFFF",
                width: "100%",
                padding: "12px 16px",
                fontSize: "16px",
                textAlign: "center",
                fontWeight: "600",
                backgroundColor: "#000000FF",
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
                borderBottomLeftRadius: "6px",
                borderBottomRightRadius: "6px",
              },
              "style@md": {
                marginTop: "0px",
                marginBottom: "0px",
              },
            },
            children: [],
          },
        ],
      },
    ],
  },
};
